<div class="aca-admin aca-docs">
  <aca-page-header icon="description" [title]="'DMS.ALL_DOCUMENTS.B46EA8' | translate" [subtitle]="'DMS.UI.BF952D' | translate" />

  <!-- ── filter bar ─────────────────────────────────────────────────────── -->
  <div class="aca-docs__filterbar">
    <div class="aca-docs__filters">
      <label class="aca-docs__filter">
        <span class="aca-docs__filterlabel">{{ 'DMS.ALL_DOCUMENTS.42FB18' | translate }}</span>
        <select class="aca-docs__select" [(ngModel)]="filters.documentType" (ngModelChange)="applyFilters()">
          <option value="">{{ 'DMS.ALL_DOCUMENTS.56EFFD' | translate }}</option>
          <option *ngFor="let option of documentTypes" [value]="option.value">{{ option.label | translate }}</option>
        </select>
      </label>

      <label class="aca-docs__filter" *ngIf="departments.length">
        <span class="aca-docs__filterlabel">{{ 'DMS.ALL_DOCUMENTS.DAFFE6' | translate }}</span>
        <select class="aca-docs__select" [(ngModel)]="filters.department" (ngModelChange)="applyFilters()">
          <option value="">{{ 'DMS.ALL_DOCUMENTS.56EFFD' | translate }}</option>
          <option *ngFor="let option of departments" [value]="option.value">{{ option.label | translate }} ({{ option.count }})</option>
        </select>
      </label>

      <form class="aca-docs__searchfilter" *ngIf="!departments.length" (submit)="$event.preventDefault(); applyFilters()">
        <span class="aca-docs__filterlabel">{{ 'DMS.ALL_DOCUMENTS.DAFFE6' | translate }}</span>
        <input
          type="text"
          [placeholder]="'DMS.ALL_DOCUMENTS.56EFFD' | translate"
          [attr.aria-label]="'DMS.ALL_DOCUMENTS.56EFFD' | translate"
          [(ngModel)]="filters.department"
          name="department"
          autocomplete="off"
        />
      </form>

      <label class="aca-docs__filter">
        <span class="aca-docs__filterlabel">{{ 'DMS.ALL_DOCUMENTS.9A4FA6' | translate }}</span>
        <select class="aca-docs__select" [(ngModel)]="filters.status" (ngModelChange)="applyFilters()">
          <option value="">{{ 'DMS.ALL_DOCUMENTS.56EFFD' | translate }}</option>
          <option *ngFor="let option of statuses" [value]="option.value">{{ option.label | translate }}</option>
        </select>
      </label>

      <label class="aca-docs__filter" *ngIf="creators.length">
        <span class="aca-docs__filterlabel">{{ 'DMS.ALL_DOCUMENTS.9BE3B3' | translate }}</span>
        <select class="aca-docs__select" [(ngModel)]="filters.creator" (ngModelChange)="applyFilters()">
          <option value="">{{ 'DMS.ALL_DOCUMENTS.56EFFD' | translate }}</option>
          <option *ngFor="let option of creators" [value]="option.value">{{ option.label | translate }} ({{ option.count }})</option>
        </select>
      </label>

      <form class="aca-docs__searchfilter" *ngIf="!creators.length" (submit)="$event.preventDefault(); applyFilters()">
        <span class="aca-docs__filterlabel">{{ 'DMS.ALL_DOCUMENTS.9BE3B3' | translate }}</span>
        <input
          type="text"
          [placeholder]="'DMS.ALL_DOCUMENTS.56EFFD' | translate"
          [attr.aria-label]="'DMS.ALL_DOCUMENTS.56EFFD' | translate"
          [(ngModel)]="filters.creator"
          name="creator"
          autocomplete="off"
        />
      </form>

      <form class="aca-docs__searchfilter" (submit)="$event.preventDefault(); applyFilters()">
        <mat-icon>search</mat-icon>
        <input
          type="text"
          [placeholder]="'DMS.ALL_DOCUMENTS.DCDB29' | translate"
          [(ngModel)]="filters.term"
          name="term"
          autocomplete="off"
          data-automation-id="dms-docs-search"
        />
      </form>
    </div>

    <div class="aca-docs__filteractions">
      <button type="button" class="aca-docs__link" *ngIf="hasFilters" (click)="clearFilters()">{{ 'DMS.ALL_DOCUMENTS.1C5830' | translate }}</button>
      <a class="aca-docs__primary" href="#/upload"> <mat-icon>add</mat-icon>{{ 'DMS.ALL_DOCUMENTS.9DA020' | translate }}</a>
    </div>
  </div>

  <!-- ── summary cards ──────────────────────────────────────────────────── -->
  <div class="aca-docs__stats" *ngIf="counts() as c">
    <button type="button" class="aca-docs__stat" [class.aca-docs__stat--on]="!filters.status" (click)="filterByStatus('')">
      <span class="aca-docs__staticon aca-docs__staticon--total"><mat-icon>description</mat-icon></span>
      <span class="aca-docs__stattext">
        <span class="aca-docs__statlabel">{{ 'DMS.ALL_DOCUMENTS.56EFFD' | translate }}</span>
        <span class="aca-docs__statvalue">{{ countText(c.total) }}</span>
        <span class="aca-docs__statunit">{{ 'DMS.ALL_DOCUMENTS.B21E61' | translate }}</span>
      </span>
    </button>

    <button type="button" class="aca-docs__stat" [class.aca-docs__stat--on]="filters.status === 'draft'" (click)="filterByStatus('draft')">
      <span class="aca-docs__staticon aca-docs__staticon--draft"><mat-icon>edit</mat-icon></span>
      <span class="aca-docs__stattext">
        <span class="aca-docs__statlabel">{{ 'DMS.ALL_DOCUMENTS.D1F1D6' | translate }}</span>
        <span class="aca-docs__statvalue">{{ countText(c.draft) }}</span>
        <span class="aca-docs__statunit">{{ 'DMS.ALL_DOCUMENTS.B21E61' | translate }}</span>
      </span>
    </button>

    <button type="button" class="aca-docs__stat" [class.aca-docs__stat--on]="filters.status === 'pending'" (click)="filterByStatus('pending')">
      <span class="aca-docs__staticon aca-docs__staticon--pending"><mat-icon>schedule</mat-icon></span>
      <span class="aca-docs__stattext">
        <span class="aca-docs__statlabel">{{ 'DMS.ALL_DOCUMENTS.F792C7' | translate }}</span>
        <span class="aca-docs__statvalue">{{ countText(c.pending) }}</span>
        <span class="aca-docs__statunit">{{ 'DMS.ALL_DOCUMENTS.B21E61' | translate }}</span>
      </span>
    </button>

    <button type="button" class="aca-docs__stat" [class.aca-docs__stat--on]="filters.status === 'approved'" (click)="filterByStatus('approved')">
      <span class="aca-docs__staticon aca-docs__staticon--approved"><mat-icon>check_circle</mat-icon></span>
      <span class="aca-docs__stattext">
        <span class="aca-docs__statlabel">{{ 'DMS.ALL_DOCUMENTS.8F71E0' | translate }}</span>
        <span class="aca-docs__statvalue">{{ countText(c.approved) }}</span>
        <span class="aca-docs__statunit">{{ 'DMS.ALL_DOCUMENTS.B21E61' | translate }}</span>
      </span>
    </button>

    <div class="aca-docs__stat aca-docs__stat--static" [matTooltip]="'DMS.ALL_DOCUMENTS.8E90E4' | translate">
      <span class="aca-docs__staticon aca-docs__staticon--expired"><mat-icon>error_outline</mat-icon></span>
      <span class="aca-docs__stattext">
        <span class="aca-docs__statlabel">{{ 'DMS.ALL_DOCUMENTS.0C048F' | translate }}</span>
        <span class="aca-docs__statvalue">{{ countText(c.expired) }}</span>
        <span class="aca-docs__statunit">{{ 'DMS.ALL_DOCUMENTS.B21E61' | translate }}</span>
      </span>
    </div>
  </div>

  <!-- ── table + details panel ──────────────────────────────────────────── -->
  <div class="aca-docs__body" [class.aca-docs__body--split]="selected()">
    <section class="aca-docs__main">
      <div class="aca-docs__toolbar">
        <span class="aca-docs__range" *ngIf="!loading()">
          {{ 'DMS.UI.1D31FB' | translate }} {{ rangeStart | number }}–{{ rangeEnd | number }}
          <ng-container *ngIf="total() !== null"
            >{{ 'DMS.UI.F2DB2C' | translate }} {{ total() | number }} {{ 'DMS.UI.4514CB' | translate }}</ng-container
          >
        </span>
        <span class="aca-docs__range" *ngIf="loading()">{{ 'DMS.ALL_DOCUMENTS.D14A5E' | translate }}</span>

        <div class="aca-docs__toolbarright">
          <label class="aca-docs__filter">
            <span class="aca-docs__filterlabel">{{ 'DMS.ALL_DOCUMENTS.58DB33' | translate }}</span>
            <select class="aca-docs__select" [ngModel]="sortField" (ngModelChange)="changeSort($event)">
              <option *ngFor="let sort of sorts" [value]="sort.field">{{ sort.label | translate }}</option>
            </select>
          </label>

          <button
            type="button"
            class="aca-docs__iconbtn"
            (click)="toggleDirection()"
            [matTooltip]="ascending ? ('DMS.UI.CD099A' | translate) : ('DMS.UI.779FA0' | translate)"
            [attr.aria-label]="ascending ? ('DMS.UI.CD099A' | translate) : ('DMS.UI.779FA0' | translate)"
          >
            <mat-icon>{{ ascending ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
          </button>

          <div class="aca-docs__viewtoggle">
            <button
              type="button"
              class="aca-docs__iconbtn"
              [class.aca-docs__iconbtn--on]="view() === 'list'"
              (click)="setView('list')"
              [matTooltip]="'DMS.ALL_DOCUMENTS.3519B3' | translate"
              [attr.aria-label]="'DMS.ALL_DOCUMENTS.3519B3' | translate"
            >
              <mat-icon>view_list</mat-icon>
            </button>
            <button
              type="button"
              class="aca-docs__iconbtn"
              [class.aca-docs__iconbtn--on]="view() === 'grid'"
              (click)="setView('grid')"
              [matTooltip]="'DMS.ALL_DOCUMENTS.81D7AA' | translate"
              [attr.aria-label]="'DMS.ALL_DOCUMENTS.81D7AA' | translate"
            >
              <mat-icon>grid_view</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <!-- the rows ticked, and what can be done to all of them at once -->
      <div class="aca-docs__bulkbar" *ngIf="checkedCount()" role="region" [attr.aria-label]="'DMS.BULK.ACTIONS' | translate">
        <span class="aca-docs__bulkcount" aria-live="polite" data-automation-id="dms-docs-bulk-count">{{
          'DMS.BULK.SELECTED' | translate: { count: checkedCount() }
        }}</span>
        <button
          type="button"
          class="aca-docs__outline"
          (click)="downloadChecked()"
          [disabled]="working() || loading()"
          data-automation-id="dms-docs-bulk-download"
        >
          <mat-icon>download</mat-icon>{{ 'DMS.BULK.DOWNLOAD' | translate }}
        </button>
        <button
          type="button"
          class="aca-docs__outline"
          (click)="favoriteChecked()"
          [disabled]="working() || loading()"
          data-automation-id="dms-docs-bulk-favorite"
        >
          <mat-icon>star_border</mat-icon>{{ 'DMS.BULK.FAVORITE' | translate }}
        </button>
        <button
          type="button"
          class="aca-docs__danger"
          (click)="trashChecked()"
          [disabled]="working() || loading()"
          data-automation-id="dms-docs-bulk-trash"
        >
          <mat-icon>delete_outline</mat-icon>{{ 'DMS.BULK.TRASH' | translate }}
        </button>
        <button type="button" class="aca-docs__link" (click)="clearChecks()" data-automation-id="dms-docs-bulk-clear">
          {{ 'DMS.BULK.CLEAR' | translate }}
        </button>
      </div>

      <mat-progress-bar mode="indeterminate" *ngIf="loading() || working()" />

      <aca-page-state
        *ngIf="failed()"
        state="error"
        [title]="'DMS.ALL_DOCUMENTS.DD7052' | translate"
        [message]="failed()"
        [actionLabel]="'DMS.UI.324E7E' | translate"
        (action)="reload()"
      />

      <aca-page-state
        *ngIf="!failed() && !loading() && !rows().length"
        state="empty"
        [title]="'DMS.ALL_DOCUMENTS.CB46FB' | translate"
        [message]="hasFilters ? ('DMS.UI.724E3C' | translate) : ('DMS.UI.0BBE95' | translate)"
        [actionLabel]="hasFilters ? ('DMS.UI.864B57' | translate) : ''"
        (action)="clearFilters()"
      />

      <!-- list view -->
      <div class="aca-docs__tablewrap" *ngIf="!failed() && rows().length && view() === 'list'">
        <table class="aca-docs__table">
          <thead>
            <tr>
              <th class="aca-docs__th aca-docs__th--check">
                <mat-checkbox
                  [checked]="allChecked()"
                  [indeterminate]="someChecked()"
                  (change)="toggleAllChecks()"
                  [attr.aria-label]="'DMS.BULK.SELECT_PAGE' | translate"
                  data-automation-id="dms-docs-select-all"
                />
              </th>
              <th class="aca-docs__th aca-docs__th--name">{{ 'DMS.ALL_DOCUMENTS.85B482' | translate }}</th>
              <th class="aca-docs__th">{{ 'DMS.ALL_DOCUMENTS.AEABC8' | translate }}</th>
              <th class="aca-docs__th">{{ 'DMS.ALL_DOCUMENTS.74B287' | translate }}</th>
              <th class="aca-docs__th">{{ 'DMS.ALL_DOCUMENTS.508B08' | translate }}</th>
              <th class="aca-docs__th">{{ 'DMS.ALL_DOCUMENTS.9CFD2F' | translate }}</th>
              <th class="aca-docs__th">{{ 'DMS.ALL_DOCUMENTS.2E8C46' | translate }}</th>
              <th class="aca-docs__th aca-docs__th--version">{{ 'DMS.ALL_DOCUMENTS.9A0D5E' | translate }}</th>
              <th class="aca-docs__th aca-docs__th--actions"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="aca-docs__row"
              *ngFor="let row of rows(); trackBy: trackById"
              [class.aca-docs__row--selected]="selected()?.id === row.id"
              [class.aca-docs__row--checked]="isChecked(row)"
              [attr.data-automation-id]="'dms-docs-row-' + row.name"
              (click)="select(row)"
              (dblclick)="open(row)"
            >
              <td class="aca-docs__td aca-docs__td--check" (click)="$event.stopPropagation()" (dblclick)="$event.stopPropagation()">
                <mat-checkbox
                  [checked]="isChecked(row)"
                  (change)="toggleCheck(row)"
                  [attr.aria-label]="'DMS.BULK.SELECT_ROW' | translate: { name: row.name }"
                  [attr.data-automation-id]="'dms-docs-select-' + row.name"
                />
              </td>
              <td class="aca-docs__td aca-docs__td--name">
                <span class="aca-docs__badge" [ngClass]="badgeClass(row)">
                  <mat-icon *ngIf="row.isFolder">folder</mat-icon>
                  <ng-container *ngIf="!row.isFolder">{{ badge(row) }}</ng-container>
                </span>
                <span class="aca-docs__namebox">
                  <span class="aca-docs__name">{{ row.name }}</span>
                  <span class="aca-docs__code" *ngIf="row.documentCode">{{ row.documentCode }}</span>
                </span>
                <span
                  class="aca-docs__chip aca-docs__chip--secret"
                  *ngIf="row.confidentiality === 'confidential' || row.confidentiality === 'secret'"
                >
                  {{ label(row.confidentiality) | translate }}
                </span>
              </td>
              <td class="aca-docs__td">{{ (label(row.documentType) | translate) || '—' }}</td>
              <td class="aca-docs__td">{{ row.department || '—' }}</td>
              <td class="aca-docs__td">{{ row.modifiedAt | acaDate: 'd MMM y HH:mm' }}</td>
              <td class="aca-docs__td">
                <span class="aca-docs__owner">
                  <span class="aca-docs__avatar">{{ initials(row.ownerName) }}</span>
                  {{ row.ownerName || '—' }}
                </span>
              </td>
              <td class="aca-docs__td">
                <span class="aca-docs__chip" [ngClass]="statusClass(row.status)" *ngIf="row.status">{{ label(row.status) | translate }}</span>
                <span *ngIf="!row.status">—</span>
              </td>
              <td class="aca-docs__td aca-docs__td--version">{{ row.versionLabel || '—' }}</td>
              <td class="aca-docs__td aca-docs__td--actions">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="rowMenu"
                  (click)="$event.stopPropagation()"
                  [matTooltip]="'DMS.ALL_DOCUMENTS.6D5E7B' | translate"
                  [attr.aria-label]="'DMS.ALL_DOCUMENTS.6D5E7B' | translate"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #rowMenu="matMenu">
                  <button mat-menu-item (click)="open(row)">
                    <mat-icon>open_in_new</mat-icon><span>{{ 'DMS.ALL_DOCUMENTS.22AADB' | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="select(row)">
                    <mat-icon>info</mat-icon><span>{{ 'DMS.ALL_DOCUMENTS.FF9D41' | translate }}</span>
                  </button>
                  <button mat-menu-item (click)="download(row)" [disabled]="row.isFolder">
                    <mat-icon>download</mat-icon><span>{{ 'DMS.ALL_DOCUMENTS.13EA03' | translate }}</span>
                  </button>
                </mat-menu>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- grid view -->
      <div class="aca-docs__grid" *ngIf="!failed() && rows().length && view() === 'grid'">
        <button
          type="button"
          class="aca-docs__card"
          *ngFor="let row of rows(); trackBy: trackById"
          [class.aca-docs__card--selected]="selected()?.id === row.id"
          (click)="select(row)"
          (dblclick)="open(row)"
        >
          <span class="aca-docs__badge aca-docs__badge--lg" [ngClass]="badgeClass(row)">
            <mat-icon *ngIf="row.isFolder">folder</mat-icon>
            <ng-container *ngIf="!row.isFolder">{{ badge(row) }}</ng-container>
          </span>
          <span class="aca-docs__cardname">{{ row.name }}</span>
          <span class="aca-docs__cardmeta">{{ label(row.documentType) || (row.isFolder ? 'DMS.UI.848311' : 'DMS.UI.D997F7') | translate }}</span>
          <span class="aca-docs__chip" [ngClass]="statusClass(row.status)" *ngIf="row.status">{{ label(row.status) | translate }}</span>
        </button>
      </div>

      <!-- pagination -->
      <div class="aca-docs__pager" *ngIf="rows().length">
        <label class="aca-docs__filter">
          <span class="aca-docs__filterlabel">{{ 'DMS.ALL_DOCUMENTS.518D91' | translate }}</span>
          <select class="aca-docs__select" [ngModel]="pageSize" (ngModelChange)="changePageSize($event)">
            <option *ngFor="let size of pageSizes" [value]="size">{{ size }}</option>
          </select>
        </label>

        <div class="aca-docs__pages">
          <button type="button" class="aca-docs__iconbtn" [disabled]="pageIndex === 0" (click)="goToPage(pageIndex - 1)">
            <mat-icon>chevron_left</mat-icon>
          </button>

          <ng-container *ngFor="let page of pageNumbers">
            <span class="aca-docs__gap" *ngIf="page === -1">…</span>
            <button type="button" class="aca-docs__page" *ngIf="page !== -1" [class.aca-docs__page--on]="page === pageIndex" (click)="goToPage(page)">
              {{ page + 1 }}
            </button>
          </ng-container>

          <span class="aca-docs__page aca-docs__page--on" *ngIf="pageCount === null">{{ pageIndex + 1 }}</span>

          <button type="button" class="aca-docs__iconbtn" [disabled]="!canGoNext" (click)="goToPage(pageIndex + 1)">
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      </div>
    </section>

    <!-- ── details panel ────────────────────────────────────────────────── -->
    <aside class="aca-docs__panel" *ngIf="selected() as row">
      <header class="aca-docs__panelhead">
        <h2 class="aca-docs__paneltitle">{{ row.name }}</h2>
        <button
          mat-icon-button
          (click)="closePanel()"
          [matTooltip]="'DMS.ALL_DOCUMENTS.96D79D' | translate"
          [attr.aria-label]="'DMS.ALL_DOCUMENTS.96D79D' | translate"
        >
          <mat-icon>close</mat-icon>
        </button>
      </header>

      <div class="aca-docs__preview" *ngIf="!row.isFolder">
        <img *ngIf="!previewFailed()" [src]="thumbnailUrl(row)" alt="" (error)="onThumbnailError()" />
        <span class="aca-docs__badge aca-docs__badge--lg" [ngClass]="badgeClass(row)" *ngIf="previewFailed()">{{ badge(row) }}</span>
      </div>

      <dl class="aca-docs__props">
        <dt>{{ 'DMS.ALL_DOCUMENTS.AEABC8' | translate }}</dt>
        <dd>{{ label(row.documentType) || (row.isFolder ? 'DMS.UI.848311' : '—') | translate }}</dd>

        <dt>{{ 'DMS.ALL_DOCUMENTS.0B315E' | translate }}</dt>
        <dd>{{ row.documentCode || '—' }}</dd>

        <dt>{{ 'DMS.ALL_DOCUMENTS.74B287' | translate }}</dt>
        <dd>{{ row.department || '—' }}</dd>

        <dt>{{ 'DMS.ALL_DOCUMENTS.9CFD2F' | translate }}</dt>
        <dd>{{ row.ownerName || '—' }}</dd>

        <dt>{{ 'DMS.ALL_DOCUMENTS.78F0E6' | translate }}</dt>
        <dd>{{ row.createdAt | acaDate: 'd MMM y HH:mm' }}</dd>

        <dt>{{ 'DMS.ALL_DOCUMENTS.508B08' | translate }}</dt>
        <dd>{{ row.modifiedAt | acaDate: 'd MMM y HH:mm' }}</dd>

        <dt *ngIf="!row.isFolder">{{ 'DMS.ALL_DOCUMENTS.E06CAF' | translate }}</dt>
        <dd *ngIf="!row.isFolder">{{ formatSize(row.sizeInBytes) }}</dd>

        <dt *ngIf="!row.isFolder">{{ 'DMS.ALL_DOCUMENTS.9A0D5E' | translate }}</dt>
        <dd *ngIf="!row.isFolder">{{ row.versionLabel || '—' }}</dd>

        <dt>{{ 'DMS.ALL_DOCUMENTS.2E8C46' | translate }}</dt>
        <dd>
          <span class="aca-docs__chip" [ngClass]="statusClass(row.status)" *ngIf="row.status">{{ label(row.status) | translate }}</span>
          <span *ngIf="!row.status">—</span>
        </dd>

        <dt>{{ 'DMS.ALL_DOCUMENTS.5DDB25' | translate }}</dt>
        <dd>{{ (label(row.confidentiality) | translate) || '—' }}</dd>
      </dl>

      <p class="aca-docs__description" *ngIf="row.description">{{ row.description }}</p>

      <div class="aca-docs__panelactions">
        <button type="button" class="aca-docs__primary aca-docs__primary--block" (click)="download(row)" [disabled]="row.isFolder">
          <mat-icon>download</mat-icon>{{ 'DMS.ALL_DOCUMENTS.13EA03' | translate }}
        </button>
        <button type="button" class="aca-docs__outline" (click)="open(row)">
          <mat-icon>open_in_new</mat-icon>{{ 'DMS.ALL_DOCUMENTS.22AADB' | translate }}
        </button>
      </div>
    </aside>
  </div>
</div>
